<mat-tab-group class="imageLanding">
  <mat-tab label="Overages">
    <app-image-search></app-image-search>
  </mat-tab>
  <mat-tab label="Salvage" class="imageLanding_salvage">
    <app-salvage></app-salvage>
  </mat-tab>
</mat-tab-group>
